import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
axios.defaults.withCredentials = true;

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null); // null = checking, false = anon, {email} = authed
    const [ready, setReady] = useState(false);

    const refresh = useCallback(async () => {
        try {
            const { data } = await axios.get(`${API}/auth/me`);
            setUser(data);
        } catch {
            setUser(false);
        } finally {
            setReady(true);
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const login = async (email, password) => {
        const { data } = await axios.post(`${API}/auth/login`, {
            email,
            password,
        });
        // Also stash token as fallback for browsers that block 3rd-party cookies
        if (data.access_token) {
            localStorage.setItem("truheal_admin_token", data.access_token);
            axios.defaults.headers.common["Authorization"] = `Bearer ${data.access_token}`;
        }
        setUser({ email: data.email, role: data.role });
        return data;
    };

    const logout = async () => {
        try {
            await axios.post(`${API}/auth/logout`);
        } catch {
            /* ignore logout errors */
        }
        localStorage.removeItem("truheal_admin_token");
        delete axios.defaults.headers.common["Authorization"];
        setUser(false);
    };

    // Restore Authorization header from localStorage on mount
    useEffect(() => {
        const token = localStorage.getItem("truheal_admin_token");
        if (token) {
            axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        }
    }, []);

    return (
        <AuthContext.Provider value={{ user, ready, login, logout, refresh }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
